import "tailwindcss/tailwind.css";
import ProSettings from "./components/GalleryEditor/ProSettings/ProSettings";
export default { ProSettings };
